import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-locize-backend';

export const COMMON_OPTIONS = {
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  initImmediate: false,
  react: {
    useSuspense: false,
  },
  // When using a new, previously unused i18n key in development, the key automatically gets saved in Locize
  saveMissing: true,
  backend: {
    projectId: import.meta.env.LOCIZE_PROJECT_ID,
    apiKey: import.meta.env.LOCIZE_API_KEY,
    cdnType: 'pro',
    referenceLng: 'en',
  },
  returnNull: false,
} as const;

export const init = () =>
  i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      ...COMMON_OPTIONS,
    });

export { i18n };
